import CssBaseline from '@mui/material/CssBaseline';
import { GlobalStyles } from '@mui/material';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';

import { useTranslate } from 'src/locales';

import { useSettingsContext } from 'src/components/settings';

import { createTheme } from './create-theme';
import { RTL } from './with-settings/right-to-left';
import { schemeConfig } from './color-scheme-script';

// ----------------------------------------------------------------------

export function ThemeProvider({ children }) {
  const { currentLang } = useTranslate();

  const settings = useSettingsContext();

  const theme = createTheme(currentLang?.systemValue, settings);

  return (
    <CssVarsProvider
      theme={theme}
      defaultMode={schemeConfig.defaultMode}
      modeStorageKey={schemeConfig.modeStorageKey}
    >
      <CssBaseline />
      <GlobalStyles
        styles={{
          '@keyframes magicPulse': {
            '0%': {
              transform: 'scale(1)',
              opacity: 0.8,
            },
            '50%': {
              transform: 'scale(1.5)',
              opacity: 1,
            },
            '100%': {
              transform: 'scale(1)',
              opacity: 0.8,
            },
          },
        }}
      />
      <RTL direction={settings.direction}>{children}</RTL>
    </CssVarsProvider>
  );
}
